import { Typography, Space, Select, Button, Form, Row, Col } from "antd";
import {
  LeftOutlined,
  RightOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { useSharedState } from "../../../Shared/Services/WindowSizeService";
import useWindowSize from "../../../Shared/Utils/windowResizeUtils";
import MenuItem from "antd/es/menu/MenuItem";
import useStatesHook from "./useStatesHook";
import "./CustomToolBar.scss";

const { Title } = Typography;

const CustomToolBar = (props) => {
  const windowSize$ = useSharedState();
  const { width } = useWindowSize();
  const [form] = Form.useForm();
  const isMobile = width <= 768;
  const getLists = useStatesHook();
  const { statesList, drugClasses } = getLists;


  const handleView = (event) => {
    props.updateView(event);
  }

  const clearFieldValues = () => {
     form.resetFields();
  }

  return (
    <div classNmae="medicaid-toolbar">
      <Form
        form={form}
        name="validateOnly"
        layout="vertical"
        autoComplete="off"
      >
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Title
                level={5}
                style={{ margin: "0 10px 0 0", cursor: "pointer" }}
                onClick={() => {
                  props.onNavigate("TODAY");
                  props.onView("month");
                }}
              >
                <CalendarOutlined style={{ marginRight: 8 }} />
                Today
              </Title>

              <Space>
                <LeftOutlined
                  style={{ fontSize: 16, cursor: "pointer" }}
                  onClick={() => props.onNavigate("PREV")}
                />
                <RightOutlined
                  style={{ fontSize: 16, cursor: "pointer" }}
                  onClick={() => props.onNavigate("NEXT")}
                />
              </Space>

              <span className="rbc-toolbar-label" style={{ marginLeft: 12 }}>
                {props.label}
              </span>
            </div>
          </Col>
          <Col>
            <Select
              value={props.view}
              onChange={handleView}
              placeholder="Select View"
              style={{ width: isMobile ? 80 : 120, paddingLeft: "5px" }}
            >
              <MenuItem value="month">Month</MenuItem>
              <MenuItem value="agenda">Agenda</MenuItem>
            </Select>
          </Col>
          <Col>
            <Form.Item name="states">
              <Select
                placeholder="Select States"
                mode="multiple"
                options={statesList}
                style={{ width: isMobile ? 60 : 300 }}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="drugClass">
              <Select
                mode="multiple"
                options={drugClasses}
                placeholder="Select drug classes"
                style={{ width: isMobile ? 60 : 300 }}
              />
            </Form.Item>
          </Col>
          <Col>
            <Button type="primary" onClick={clearFieldValues}>
              Clear
            </Button>
          </Col>
        </Row>
      </Form>
      {/* </div> */}
      {/* <div style={{ paddingLeft: "5px" }}>
          <Button type="primary" onClick={clearFieldValues}>
            Clear
          </Button>
        </div> */}
    </div>
  );
};

export default CustomToolBar;
